var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
//Language Translation
import { useTranslation } from "react-i18next";
//validations functions
import { checkEmailValidation, checkMobileValidation, checkStringValidation, checkZipNumberValidation } from "./Validation";
//get Country,State Data
import { getStates } from "country-state-picker";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerAddress, getAllCustomersAction } from "../../reduxStore/actions/salesRepDataAction";
import { isLoading } from "../../services/behaviorSubjectService";
import store from "../../reduxStore/store";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import { Typography } from "@mui/material";
import { SharedFunctions } from "../SharedFunctions";
import { EDIT_ORDER_FLAG, IS_BILLING_ADDRESS, IS_SHIPPING_ADDRESS } from "../Constant";
import { getLoggedInRepDetailsFromSession } from "../../services/apiServices/salesRepDataService";
export function CustomerDetailsBL() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g;
    var t = useTranslation().t; //* Translation *
    var _h = SharedFunctions(), filterprovince = _h.filterprovince, getProvinceOfShopify = _h.getProvinceOfShopify, getCountriesList = _h.getCountriesList;
    var salesRepId = getLoggedInRepDetailsFromSession().CustomerId;
    // ** Get Data **
    var dispatch = useDispatch();
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); });
    //editOrder - Make it reactive to Redux changes
    var _j = useState((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) !== null && _a !== void 0 ? _a : {}), editOrderReduxData = _j[0], setEditOrderReduxData = _j[1];
    // Update local state when Redux editDraftOrder changes (e.g., when cleared on tab switch)
    useEffect(function () {
        var _a;
        setEditOrderReduxData((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) !== null && _a !== void 0 ? _a : {});
    }, [salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder]);
    //input field values
    var _k = useState({
        customerName: "",
        mobileNumber: "",
        emailId: "",
        companyName: "",
        firstName: "",
        lastName: "",
        address1: "",
        address2: "",
        city: "",
        zipNumber: "",
        shippingAddress: "",
        selectCountry: "",
        selectCountryCode: "",
        selectCountryState: "",
        countriesStateData: [],
        billingAddress: "",
        billing_mobileNumber: "",
        billing_companyName: "",
        billing_firstName: "",
        billing_lastName: "",
        billing_address1: "",
        billing_address2: "",
        billing_city: "",
        billing_zipNumber: "",
        billing_selectCountry: "",
        billing_selectCountryCode: "",
        billing_selectCountryState: "",
        billing_countriesStateData: [],
    }), customerInfo = _k[0], setCustomerInfo = _k[1];
    var _l = useState({
        firstName: "",
        lastName: "",
        address1: "",
        address2: "",
        selectCountry: "",
        selectCountryState: "",
        city: "",
        zipNumber: "",
        companyName: "",
        mobileNumber: "",
    }), customerDefaultAddress = _l[0], setCustomerDefaultAddress = _l[1];
    var _m = useState("isShippingAddress"), addressType = _m[0], setAddressType = _m[1];
    var _o = useState(false), newCustomerModal = _o[0], setNewCustomerModal = _o[1];
    var _p = useState(false), addressModal = _p[0], setAddressModal = _p[1];
    var _q = useState(false), isEditAddress = _q[0], setIsEditAddress = _q[1];
    var _r = useState(false), orderCreatedSuccesfullyFlag = _r[0], setOrderCreatedSuccesfullyFlag = _r[1];
    var _s = useState([]), customerAddressOptionsData = _s[0], setCustomerAddressOptionsData = _s[1];
    //Link Btn
    var _t = useState(false), addDetailsBtn = _t[0], setAddDetailsBtn = _t[1];
    var _u = useState(false), addShippingAddressBtn = _u[0], setAddShippingAddressBtn = _u[1];
    // Order Create Btn
    var _v = useState(false), orderCreateBtn = _v[0], setOrderCreateBtn = _v[1];
    var _w = useState([]), tagWiseWholeSalePrices = _w[0], setTagWiseWholeSalePrices = _w[1];
    //Feature
    var selectFeatures = salesRepData.baseData.select ? salesRepData.baseData.select : {};
    // Disable search customer dropdown
    var _x = useState(false), isCustomerSelected = _x[0], setIsCustomerSelected = _x[1];
    // Customers popup state
    var _y = useState(false), customersPopupOpen = _y[0], setCustomersPopupOpen = _y[1];
    var _z = useState(false), customerNotHasEmail = _z[0], setCustomerNotHasEmail = _z[1];
    // Local state for customer data (separate from Redux)
    var _0 = useState(false), isSearching = _0[0], setIsSearching = _0[1];
    var _1 = useState(false), isCustomerFetching = _1[0], setIsCustomerFetching = _1[1];
    var _2 = useState(""), currentSearchTerm = _2[0], setCurrentSearchTerm = _2[1];
    var _3 = useState([]), localCustomers = _3[0], setLocalCustomers = _3[1];
    var _4 = useState({
        endCursor: ((_b = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _b === void 0 ? void 0 : _b.endCursor) || "",
        startCursor: ((_c = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _c === void 0 ? void 0 : _c.startCursor) || "",
        hasNext: ((_d = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _d === void 0 ? void 0 : _d.hasNext) || false,
        hasPrevious: ((_e = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _e === void 0 ? void 0 : _e.hasPrevious) || false,
    }), paginationState = _4[0], setPaginationState = _4[1];
    //input field error(validation)
    var _5 = useState({
        customername: false,
        email: false,
        mobileNumber: false,
        zipNumber: false,
    }), errors = _5[0], setErrors = _5[1];
    var manageMenuItems = [
        { label: t("Edit_Shipping_Address"), action: "Edit_shipping_address" },
        { label: t("Edit_Billing_Address"), action: "Edit_billing_address" },
        {
            label: t("RemoveCustomer_Msg"),
            action: "Remove_customer",
            sx: { color: "#C70A24" },
            disabled: (editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.actionEvent) === EDIT_ORDER_FLAG && (editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.isDuplicate) !== true,
        },
    ];
    var HeaderNames = [
        {
            id: "ClientName",
            label: t("customer"),
            inlineCSS: { width: "80%" },
        },
        {
            id: "ClientName",
            label: t("myCustomers_table1Column3"),
            inlineCSS: { width: "20%" },
        },
    ];
    // Initialize local customers when component mounts or Redux data changes
    useEffect(function () {
        var _a;
        if (((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _a === void 0 ? void 0 : _a.customers) && salesRepData.repAllCustomers.customers.length > 0) {
            updateLocalCustomerState(salesRepData.repAllCustomers);
        }
        else {
            fetchAllCustomers({ isNextPage: true, isSaveToStore: true, isFirstCall: true });
        }
    }, []);
    var handleUpdateReduxState = function (payloadData, actionType) {
        var updateReduxState = {
            payload: payloadData,
            type: actionType,
        };
        dispatch(updateReduxState);
    };
    // Shown when duplicate redirected to Create Order and some products were sold out / quantity adjusted
    var showQuantityAdjustedWarning = !!(((_f = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _f === void 0 ? void 0 : _f.quantityAdjustedForInventory) && ((_g = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _g === void 0 ? void 0 : _g.actionEvent) === EDIT_ORDER_FLAG);
    var handleManualAddressChange = function (field, value) {
        setCustomerInfo(function (prevCustomerInfo) {
            var _a;
            return (__assign(__assign({}, prevCustomerInfo), (_a = {}, _a[field] = value, _a)));
        });
        setIsEditAddress(true);
    };
    //Remove Error Msg
    var removeErrorsMsg = function () {
        var errorsObject = __assign({}, errors);
        errorsObject["customername"] = false;
        errorsObject["email"] = false;
        errorsObject["mobileNumber"] = false;
        errorsObject["zipNumber"] = false;
        setErrors(__assign({}, errorsObject));
    };
    //Doing Empty Field
    var EmptyFields = function () {
        setCustomerInfo(function (prevCustomerInfo) { return (__assign(__assign({}, prevCustomerInfo), { mobileNumber: "", emailId: "", companyName: "", shippingAddress: "", countriesStateData: [], billingAddress: "", billing_mobileNumber: "", billing_companyName: "", billing_countriesStateData: [] })); });
        setTagWiseWholeSalePrices([]);
        setCustomerAddressOptionsData([]);
        setAddShippingAddressBtn(false);
        handleUpdateReduxState({}, SalesRepDataActionType.CREATE_ORDER_TAB);
    };
    var clearCustomerInfoFields = function () { return ({
        customerName: "",
        mobileNumber: "",
        emailId: "",
        companyName: "",
        firstName: "",
        lastName: "",
        address1: "",
        address2: "",
        city: "",
        zipNumber: "",
        shippingAddress: "",
        selectCountry: "",
        selectCountryCode: "",
        selectCountryState: "",
        countriesStateData: [],
        billingAddress: "",
        billing_mobileNumber: "",
        billing_companyName: "",
        billing_firstName: "",
        billing_lastName: "",
        billing_address1: "",
        billing_address2: "",
        billing_city: "",
        billing_zipNumber: "",
        billing_selectCountry: "",
        billing_selectCountryCode: "",
        billing_selectCountryState: "",
        billing_countriesStateData: [],
    }); };
    var EmptyAllFieldsOnSuccess = function () {
        setCustomerInfo(__assign(__assign({}, customerInfo), clearCustomerInfoFields()));
        setEditOrderReduxData({});
    };
    var handleCustomerChange = function (event, newValue) {
        SearchByCustomer(newValue);
        if (typeof newValue === "string") {
            setCustomerInfo(function (prevCustomerInfo) { return (__assign(__assign({}, prevCustomerInfo), { customerName: "" })); });
        }
        else if (newValue && newValue.inputValue) {
            setCustomerInfo(function (prevCustomerInfo) { return (__assign(__assign({}, prevCustomerInfo), { customerName: newValue.inputValue })); });
            if (newValue !== "" || customerInfo.customerName !== "") {
                EmptyFields();
            }
        }
        else if (newValue === null) {
            EmptyFields();
        }
    };
    var mapAddressFields = function (addressData, prefix) {
        var _a;
        if (prefix === void 0) { prefix = ""; }
        return (_a = {},
            _a["".concat(prefix, "firstName")] = (addressData === null || addressData === void 0 ? void 0 : addressData.first_name) || "",
            _a["".concat(prefix, "lastName")] = (addressData === null || addressData === void 0 ? void 0 : addressData.last_name) || "",
            _a["".concat(prefix, "address1")] = (addressData === null || addressData === void 0 ? void 0 : addressData.address1) || "",
            _a["".concat(prefix, "address2")] = (addressData === null || addressData === void 0 ? void 0 : addressData.address2) || "",
            _a["".concat(prefix, "city")] = (addressData === null || addressData === void 0 ? void 0 : addressData.city) || "",
            _a["".concat(prefix, "zipNumber")] = (addressData === null || addressData === void 0 ? void 0 : addressData.zip) || "",
            _a["".concat(prefix, "selectCountry")] = (addressData === null || addressData === void 0 ? void 0 : addressData.country) || "",
            _a["".concat(prefix, "selectCountryState")] = (addressData === null || addressData === void 0 ? void 0 : addressData.province) || "",
            _a["".concat(prefix, "mobileNumber")] = (addressData === null || addressData === void 0 ? void 0 : addressData.phone) || "",
            _a["".concat(prefix, "companyName")] = (addressData === null || addressData === void 0 ? void 0 : addressData.company) || "",
            _a);
    };
    var handleSetDefaultAddress = function (addressArray, customerAdditionalDetails, key) {
        var customerDetails = { phoneNumber: "", companyName: "" };
        if (customerAdditionalDetails) {
            customerDetails.phoneNumber = customerAdditionalDetails === null || customerAdditionalDetails === void 0 ? void 0 : customerAdditionalDetails.phoneNumber;
            customerDetails.companyName = customerAdditionalDetails === null || customerAdditionalDetails === void 0 ? void 0 : customerAdditionalDetails.companyName;
        }
        else {
            customerDetails.phoneNumber = (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.mobileNumber) ? customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.mobileNumber : "";
            customerDetails.companyName = (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.companyName) ? customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.companyName : "";
        }
        var option = addressArray === null || addressArray === void 0 ? void 0 : addressArray.find(function (addr) { return addr.defaultAddr; });
        if (!option)
            return;
        if (!option.phone) {
            option.phone = customerDetails.phoneNumber;
        }
        if (!option.company) {
            option.company = customerDetails.companyName;
        }
        setCustomerInfo(function (prevCustomerInfo) { return (__assign(__assign(__assign(__assign({}, prevCustomerInfo), (key === "isShippingAddress" ? mapAddressFields(option) : {})), (key === "isBillingAddress" ? mapAddressFields(option, "billing_") : {})), (key === undefined ? __assign(__assign({}, mapAddressFields(option)), mapAddressFields(option, "billing_")) : {}))); });
        handleAutoCountryStateSet(option === null || option === void 0 ? void 0 : option.country, option === null || option === void 0 ? void 0 : option.province);
    };
    var handleSetDraftOrderAddress = function (addressArray, type) {
        var shippingAddr = type === IS_SHIPPING_ADDRESS &&
            ((addressArray === null || addressArray === void 0 ? void 0 : addressArray.find(function (addr) { return addr.id === 12345; })) ||
                (addressArray === null || addressArray === void 0 ? void 0 : addressArray.find(function (addr) { return addr.id === (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.shippingAddress); })) ||
                (addressArray === null || addressArray === void 0 ? void 0 : addressArray.find(function (addr) { return addr.defaultAddr; })));
        var billingAddr = type === IS_BILLING_ADDRESS &&
            ((addressArray === null || addressArray === void 0 ? void 0 : addressArray.find(function (addr) { return addr.id === 678910; })) ||
                (addressArray === null || addressArray === void 0 ? void 0 : addressArray.find(function (addr) { return addr.id === (customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billingAddress); })) ||
                (addressArray === null || addressArray === void 0 ? void 0 : addressArray.find(function (addr) { return addr.defaultAddr; })));
        setCustomerInfo(function (prevCustomerInfo) { return (__assign(__assign(__assign({}, prevCustomerInfo), (type === IS_SHIPPING_ADDRESS ? mapAddressFields(shippingAddr) : {})), (type === IS_BILLING_ADDRESS ? mapAddressFields(billingAddr, "billing_") : {}))); });
        if (type === IS_SHIPPING_ADDRESS) {
            handleAutoCountryStateSet(shippingAddr === null || shippingAddr === void 0 ? void 0 : shippingAddr.country, shippingAddr === null || shippingAddr === void 0 ? void 0 : shippingAddr.province, type);
        }
        else {
            handleAutoCountryStateSet(billingAddr === null || billingAddr === void 0 ? void 0 : billingAddr.country, billingAddr === null || billingAddr === void 0 ? void 0 : billingAddr.province, type);
        }
    };
    var handleSelectAddress = function (event, addrType) {
        var _a;
        var addressId = (_a = event.target.value) === null || _a === void 0 ? void 0 : _a.toString();
        // Find the selected address object
        var selectedAddress = customerAddressOptionsData.find(function (address) { return address.id.toString() === addressId; });
        if (!selectedAddress) {
            console.error("Address not found");
            return;
        }
        var isShipping = addrType === IS_SHIPPING_ADDRESS;
        var prefix = isShipping ? "" : "billing_";
        setCustomerInfo(function (prevCustomerInfo) { return (__assign(__assign({}, prevCustomerInfo), mapAddressFields(selectedAddress, prefix))); });
        setIsEditAddress(true);
        handleAutoCountryStateSet(selectedAddress.country, selectedAddress.province, addrType);
    };
    var cancelAddressModal = function () {
        setIsEditAddress(false);
        setAddressModal(false);
    };
    var handleGetOptionLabel = function (option) {
        if (typeof option === "string") {
            return option;
        }
        if (option.inputValue) {
            return option.inputValue;
        }
        return option.CustomerName;
    };
    var getCustomerMissedDetails = function () {
        var _a, _b;
        var customer_email = (_b = (_a = store.getState().salesRepData.customerNewUpdatedData) === null || _a === void 0 ? void 0 : _a.SingleShopifyCustomers) === null || _b === void 0 ? void 0 : _b.email;
        return customer_email || "";
    };
    //filter by customer... & Autoselect
    var SearchByCustomer = function (param) { return __awaiter(_this, void 0, void 0, function () {
        var CustomerDetails, customerAdditionalDetails, finalEmail_1, number, addressArray, isEditingOrder;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    setCustomerAddressOptionsData([]);
                    if (!param) return [3 /*break*/, 2];
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(getCustomerAddress((_a = param.CustomerId) !== null && _a !== void 0 ? _a : ""))];
                case 1:
                    CustomerDetails = _e.sent();
                    isLoading.next(false);
                    customerAdditionalDetails = { phoneNumber: "", companyName: "" };
                    finalEmail_1 = (param === null || param === void 0 ? void 0 : param.CustomerMailid) ? param === null || param === void 0 ? void 0 : param.CustomerMailid : getCustomerMissedDetails();
                    setCustomerNotHasEmail(!finalEmail_1);
                    setCustomerInfo(function (prevCustomerInfo) {
                        var _a, _b;
                        return (__assign(__assign({}, prevCustomerInfo), { customerName: ((_b = ((_a = param.CustomerName) !== null && _a !== void 0 ? _a : "")) === null || _b === void 0 ? void 0 : _b.trim()) ? param.CustomerName : param.CustomerMailid, emailId: finalEmail_1 }));
                    });
                    setIsCustomerSelected(true);
                    customerAdditionalDetails.companyName = (param === null || param === void 0 ? void 0 : param.CompanyName) || "";
                    if (param.CustomerPhoneno === "" || param.CustomerPhoneno === null || param.CustomerPhoneno === undefined) {
                        number = AutosetMobileNumber();
                        customerAdditionalDetails.phoneNumber = number !== null && number !== void 0 ? number : "";
                    }
                    else {
                        customerAdditionalDetails.phoneNumber = (_b = param.CustomerPhoneno) !== null && _b !== void 0 ? _b : "";
                    }
                    if (CustomerDetails && store.getState().salesRepData.wholesalePriceData) {
                        pricesBasedOnTag(CustomerDetails);
                    }
                    else {
                        setTagWiseWholeSalePrices([]);
                        handleUpdateReduxState({ wholePriceArray: [] }, SalesRepDataActionType.CREATE_ORDER_TAB);
                    }
                    if (CustomerDetails) {
                        setCustomerAddressOptionsData((_c = store.getState().salesRepData.customerNewUpdatedData) === null || _c === void 0 ? void 0 : _c.customerAddressesList);
                        addressArray = (_d = CustomerDetails === null || CustomerDetails === void 0 ? void 0 : CustomerDetails.payload) === null || _d === void 0 ? void 0 : _d.customerAddressesList;
                        isEditingOrder = (editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.actionEvent) === EDIT_ORDER_FLAG;
                        if ((addressArray === null || addressArray === void 0 ? void 0 : addressArray.length) > 0 && !isEditingOrder) {
                            handleSetDefaultAddress(addressArray, customerAdditionalDetails);
                        }
                    }
                    _e.label = 2;
                case 2:
                    //Remove Error Msg
                    removeErrorsMsg();
                    return [2 /*return*/];
            }
        });
    }); };
    var AutosetMobileNumber = function () {
        var _a, _b;
        var Mobille_Number = (_b = (_a = store.getState().salesRepData.customerNewUpdatedData) === null || _a === void 0 ? void 0 : _a.SingleShopifyCustomers) === null || _b === void 0 ? void 0 : _b.phone;
        if (Mobille_Number !== null && Mobille_Number !== undefined) {
            setCustomerInfo(function (prevCustomerInfo) { return (__assign(__assign({}, prevCustomerInfo), { mobileNumber: Mobille_Number || "", billing_mobileNumber: Mobille_Number || "" })); });
            return Mobille_Number;
        }
        return "";
    };
    //filter by country .. Autoselect CountriesStateData
    var SearchByCountry = function (value) {
        var _a, _b, _c;
        setCustomerInfo(function (prevCustomerInfo) { return (__assign(__assign({}, prevCustomerInfo), (addressType === IS_SHIPPING_ADDRESS
            ? { countriesStateData: [], selectCountryState: "" }
            : {
                billing_countriesStateData: [],
                billing_selectCountryState: "",
            }))); });
        var filteredByCountry = (_a = getCountriesList()) === null || _a === void 0 ? void 0 : _a.filter(function (Country) {
            var _a;
            return (_a = Country === null || Country === void 0 ? void 0 : Country.name.toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes(value.toLowerCase());
        });
        var selectedCountryName = (_b = filteredByCountry[0]) === null || _b === void 0 ? void 0 : _b.name;
        var ProvinceCountryStates = getProvinceOfShopify(selectedCountryName || "");
        var stateArray = (ProvinceCountryStates === null || ProvinceCountryStates === void 0 ? void 0 : ProvinceCountryStates.length) != 0 ? ProvinceCountryStates : getStates((_c = filteredByCountry[0]) === null || _c === void 0 ? void 0 : _c.code);
        setCustomerInfo(function (prevCustomerInfo) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prevCustomerInfo), (addressType === IS_SHIPPING_ADDRESS
                ? { selectCountryCode: (_a = filteredByCountry[0]) === null || _a === void 0 ? void 0 : _a.code, countriesStateData: filterprovince(stateArray !== null && stateArray !== void 0 ? stateArray : [], (_b = filteredByCountry[0].code) !== null && _b !== void 0 ? _b : "") }
                : { billing_selectCountryCode: (_c = filteredByCountry[0]) === null || _c === void 0 ? void 0 : _c.code, billing_countriesStateData: filterprovince(stateArray !== null && stateArray !== void 0 ? stateArray : [], (_d = filteredByCountry[0].code) !== null && _d !== void 0 ? _d : "") })));
        });
    };
    var handleAutoCountryStateSet = function (country, countryState, addrType) {
        var _a, _b, _c;
        var filteredByCountry = (_a = getCountriesList()) === null || _a === void 0 ? void 0 : _a.filter(function (Country) {
            var _a;
            return (_a = Country === null || Country === void 0 ? void 0 : Country.name.toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes(country === null || country === void 0 ? void 0 : country.toLowerCase());
        });
        var selectedCountryName = country ? (_b = filteredByCountry[0]) === null || _b === void 0 ? void 0 : _b.name : "";
        var ProvinceCountryStates = getProvinceOfShopify(selectedCountryName || "");
        var stateArray = (ProvinceCountryStates === null || ProvinceCountryStates === void 0 ? void 0 : ProvinceCountryStates.length) != 0 ? ProvinceCountryStates : getStates((_c = filteredByCountry[0]) === null || _c === void 0 ? void 0 : _c.code);
        var filteredStates = filterprovince(stateArray !== null && stateArray !== void 0 ? stateArray : [], filteredByCountry[0].code);
        var defaultState = filteredStates.find(function (state) { return state.toLowerCase() === (countryState === null || countryState === void 0 ? void 0 : countryState.toLowerCase()); });
        setCustomerInfo(function (prevCustomerInfo) {
            var _a, _b, _c, _d;
            return (__assign(__assign(__assign(__assign({}, prevCustomerInfo), (addrType === IS_SHIPPING_ADDRESS && {
                selectCountryCode: selectedCountryName ? (_a = filteredByCountry[0]) === null || _a === void 0 ? void 0 : _a.code : "",
                countriesStateData: filteredStates || "",
                selectCountryState: defaultState || "",
            })), (addrType === IS_BILLING_ADDRESS && {
                billing_selectCountryCode: selectedCountryName ? (_b = filteredByCountry[0]) === null || _b === void 0 ? void 0 : _b.code : "",
                billing_countriesStateData: filteredStates || "",
                billing_selectCountryState: defaultState || "",
            })), (addrType === undefined && {
                selectCountryCode: selectedCountryName ? (_c = filteredByCountry[0]) === null || _c === void 0 ? void 0 : _c.code : "",
                countriesStateData: filteredStates || "",
                selectCountryState: defaultState || "",
                billing_selectCountryCode: selectedCountryName ? (_d = filteredByCountry[0]) === null || _d === void 0 ? void 0 : _d.code : "",
                billing_countriesStateData: filteredStates || "",
                billing_selectCountryState: defaultState || "",
            })));
        });
    };
    //check Validation Fields
    var checkValidation = function (Event, validOnparam, country_Code) {
        var temp = __assign({}, errors);
        var FieldName = Event.target.name;
        switch (validOnparam) {
            case "validateOnemail":
                if (checkEmailValidation(Event.target.value.trim())) {
                    temp[FieldName] = true;
                    if (FieldName === "email") {
                        temp[FieldName] = Event.target.value.trim() === "" ? t("customerInvoice_RequiredErrorMsg") : t("customerInvoice_EmailSuggestionErrorMsg");
                    }
                }
                else {
                    temp[FieldName] = false;
                }
                break;
            case "validateOnmobileNumber":
                if (checkMobileValidation(Event.target.value.trim())) {
                    temp[FieldName] = true;
                    if (FieldName === "mobileNumber") {
                        temp[FieldName] = Event.target.value.trim() !== "" ? t("customerInvoice_MobileSuggestionErrorMsg") : "";
                    }
                }
                else {
                    temp[FieldName] = false;
                }
                break;
            case "validateOnstring":
                if (checkStringValidation(Event.target.value)) {
                    temp[FieldName] = true;
                    if (FieldName === "customername") {
                        temp[FieldName] = Event.target.value === "" ? t("customerInvoice_RequiredErrorMsg") : "";
                    }
                }
                else {
                    temp[FieldName] = false;
                }
                break;
            case "validateOnzipNumber":
                var countryCode = "";
                if (country_Code) {
                    countryCode = country_Code;
                }
                if (countryCode && checkZipNumberValidation(Event.target.value, countryCode)) {
                    temp[FieldName] = true;
                    if (FieldName === "zipNumber") {
                        temp[FieldName] = t("Customer_Invalid_pinCode_Msg");
                    }
                }
                else {
                    temp[FieldName] = false;
                }
                break;
        }
        setErrors(__assign({}, temp));
    };
    //Price based on tag
    var pricesBasedOnTag = function (CustomerDetails) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        setTagWiseWholeSalePrices([]);
        var createOrderTabReduxState = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.createOrderTab) !== null && _b !== void 0 ? _b : {};
        handleUpdateReduxState(__assign(__assign({}, createOrderTabReduxState), { wholePriceArray: [] }), SalesRepDataActionType.CREATE_ORDER_TAB);
        var wholePriceObj = {};
        var customerWholesalePriceList = store.getState().salesRepData.wholesalePriceData.AllWholesalePrices;
        var customerPriceTag = (_e = (_d = (_c = CustomerDetails === null || CustomerDetails === void 0 ? void 0 : CustomerDetails.payload) === null || _c === void 0 ? void 0 : _c.SingleShopifyCustomers) === null || _d === void 0 ? void 0 : _d.tags) === null || _e === void 0 ? void 0 : _e.split(",");
        var isPriceTag = customerPriceTag === null || customerPriceTag === void 0 ? void 0 : customerPriceTag.some(function (TagName) { var _a; return (_a = TagName === null || TagName === void 0 ? void 0 : TagName.toLowerCase()) === null || _a === void 0 ? void 0 : _a.includes("price_"); });
        if ((selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.PriceList) && isPriceTag && customerWholesalePriceList !== undefined && customerWholesalePriceList !== null) {
            try {
                var priceTagObject_1 = Object.keys(JSON.parse(customerWholesalePriceList[Object.keys(customerWholesalePriceList)[0]]));
                var priceTagforCustomer_1 = ((_f = customerPriceTag === null || customerPriceTag === void 0 ? void 0 : customerPriceTag.find(function (tag) { var _a; return priceTagObject_1 === null || priceTagObject_1 === void 0 ? void 0 : priceTagObject_1.includes((_a = tag.trim()) === null || _a === void 0 ? void 0 : _a.toLowerCase()); })) === null || _f === void 0 ? void 0 : _f.toLowerCase().trim()) || "";
                if (priceTagforCustomer_1) {
                    var wholePriceArray = (_h = (_g = Object.keys(customerWholesalePriceList)) === null || _g === void 0 ? void 0 : _g.map(function (key) {
                        var _a;
                        var _b;
                        try {
                            var parsedItem = JSON.parse(customerWholesalePriceList[key]);
                            var priceValue = (_b = parsedItem[priceTagforCustomer_1]) !== null && _b !== void 0 ? _b : 0;
                            var wholesalePrice_value = !isNaN(parseFloat(priceValue)) && isFinite(parseFloat(priceValue)) ? parseFloat(priceValue) : 0;
                            wholePriceObj = __assign(__assign({}, wholePriceObj), (_a = {}, _a[key] = wholesalePrice_value, _a));
                            return { variantId: key, wholesalePrice: parsedItem[priceTagforCustomer_1] };
                        }
                        catch (_c) {
                            return null;
                        }
                    })) === null || _h === void 0 ? void 0 : _h.filter(function (item) { return item !== null; });
                    setTagWiseWholeSalePrices(wholePriceObj);
                    handleUpdateReduxState(__assign(__assign({}, createOrderTabReduxState), { wholePriceObj: wholePriceObj }), SalesRepDataActionType.CREATE_ORDER_TAB);
                }
            }
            catch (_j) {
                return [];
            }
        }
    };
    var handleSelectShippingAddress = function (event) {
        var _a, _b, _c;
        var createOrderTabReduxState = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.createOrderTab) !== null && _b !== void 0 ? _b : {};
        var addressId = (_c = event.target.value) === null || _c === void 0 ? void 0 : _c.toString();
        setCustomerInfo(function (prevCustomerInfo) { return (__assign(__assign({}, prevCustomerInfo), { shippingAddress: addressId })); });
        // need to check redux
        handleUpdateReduxState(__assign(__assign({}, createOrderTabReduxState), { customer_shippingaddressID: addressId }), SalesRepDataActionType.CREATE_ORDER_TAB);
    };
    var handleNewCustomerModal = function () {
        setNewCustomerModal(!newCustomerModal);
    };
    var handleAddressModal = function () {
        setAddressModal(!addressModal);
    };
    var handleMenuAction = function (action) {
        var _a;
        var actionsMap = {
            Remove_customer: function () {
                EmptyAllFieldsOnSuccess();
                setIsCustomerSelected(!isCustomerSelected);
            },
            Edit_shipping_address: function () {
                setAddressType("isShippingAddress");
                getDefaultCountry("isShippingAddress");
                setAddressModal(!addressModal);
            },
            Edit_billing_address: function () {
                setAddressType("isBillingAddress");
                getDefaultCountry("isBillingAddress");
                setAddressModal(!addressModal);
            },
        };
        // Execute the action if it exists
        (_a = actionsMap[action]) === null || _a === void 0 ? void 0 : _a.call(actionsMap);
    };
    var getDefaultCountry = function (newAddressType) {
        var storedCountry = localStorage.getItem("default_".concat(newAddressType === IS_SHIPPING_ADDRESS ? "shipping" : "billing", "_country__").concat(salesRepId));
        var selectedCountry = newAddressType === IS_SHIPPING_ADDRESS ? customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.selectCountry : customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billing_selectCountry;
        if (storedCountry && !selectedCountry) {
            setCustomerInfo(function (prevCustomerInfo) { return (__assign(__assign({}, prevCustomerInfo), (newAddressType === IS_SHIPPING_ADDRESS ? { selectCountry: storedCountry, zipNumber: "" } : { billing_selectCountry: storedCountry, billing_zipNumber: "" }))); });
            SearchByCountry(storedCountry);
        }
    };
    var renderAddress = function (addressInfo) {
        if ((addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.firstName) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.lastName) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address1) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address2) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.city) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.selectCountryState) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.selectCountry) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.zipNumber) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.companyName) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.mobileNumber)) {
            return (_jsxs(Typography, __assign({ variant: "body2", className: "ST_CommonTextFont_size" }, { children: [(addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.firstName) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.lastName) || "", " ", _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.companyName) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.companyName) && _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address1) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address1) && _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address2) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address2) && _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.zipNumber) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.city) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.selectCountryState) || "", " ", ((addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.zipNumber) || (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.city) || (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.selectCountryState)) && _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.selectCountry) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.selectCountry) && _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.mobileNumber) || ""] })));
        }
        return (_jsx(Typography, __assign({ variant: "body1", color: "textSecondary" }, { children: "No Address Found" })));
    };
    var getCustomerAddressData = function (addressType) {
        if (addressType === IS_SHIPPING_ADDRESS) {
            return renderAddress(customerInfo);
        }
        else if (addressType === IS_BILLING_ADDRESS) {
            return renderAddress({
                firstName: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billing_firstName,
                lastName: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billing_lastName,
                address1: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billing_address1,
                address2: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billing_address2,
                city: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billing_city,
                selectCountryState: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billing_selectCountryState,
                selectCountry: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billing_selectCountry,
                zipNumber: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billing_zipNumber,
                companyName: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billing_companyName,
                mobileNumber: customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.billing_mobileNumber,
            });
        }
        return (_jsx(Typography, __assign({ variant: "body1", color: "textSecondary" }, { children: "No Address Found" })));
    };
    var updateLocalCustomerState = function (customerData) {
        if (customerData && (customerData === null || customerData === void 0 ? void 0 : customerData.customers)) {
            setLocalCustomers(customerData.customers);
            setPaginationState({
                endCursor: (customerData === null || customerData === void 0 ? void 0 : customerData.endCursor) || "",
                startCursor: (customerData === null || customerData === void 0 ? void 0 : customerData.startCursor) || "",
                hasNext: (customerData === null || customerData === void 0 ? void 0 : customerData.hasNext) || false,
                hasPrevious: (customerData === null || customerData === void 0 ? void 0 : customerData.hasPrevious) || false,
            });
        }
    };
    // Customers popup handlers
    var handleOpenCustomersPopup = function () {
        setCustomersPopupOpen(true);
    };
    var handleCloseCustomersPopup = function () {
        var _a;
        setCustomersPopupOpen(false);
        if (((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _a === void 0 ? void 0 : _a.customers) && salesRepData.repAllCustomers.customers.length > 0) {
            updateLocalCustomerState(salesRepData.repAllCustomers);
            setCurrentSearchTerm("");
        }
    };
    var handleCustomerSelectFromPopup = function (customer) {
        var customerForSearch = {
            CustomerId: customer === null || customer === void 0 ? void 0 : customer.customerId,
            CustomerName: "".concat(customer === null || customer === void 0 ? void 0 : customer.firstName, " ").concat(customer === null || customer === void 0 ? void 0 : customer.lastName),
            CustomerMailid: customer === null || customer === void 0 ? void 0 : customer.emailId,
            CompanyName: customer === null || customer === void 0 ? void 0 : customer.companyName,
            CustomerPhoneno: "",
        };
        SearchByCustomer(customerForSearch);
        handleCloseCustomersPopup();
    };
    var handleCreateNewCustomerFromPopup = function () {
        handleCloseCustomersPopup();
        handleNewCustomerModal();
    };
    // After a new customer is created from the create-order flow, look it up by email
    // (the create API does not return an id) and auto-select it in the customer text box.
    var handleNewCustomerCreated = function (createdCustomer) { return __awaiter(_this, void 0, void 0, function () {
        var createdEmail, response, customers, matchedCustomer, customerForSearch, error_1;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    createdEmail = (_a = createdCustomer === null || createdCustomer === void 0 ? void 0 : createdCustomer.email) === null || _a === void 0 ? void 0 : _a.trim();
                    if (!createdEmail) {
                        EmptyAllFieldsOnSuccess();
                        return [2 /*return*/];
                    }
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 6, 7, 8]);
                    isLoading.next(true);
                    return [4 /*yield*/, fetchAllCustomers({
                            isNextPage: true,
                            searchString: createdEmail,
                            endCursor: "",
                            startCursor: "",
                            isSaveToStore: false,
                        })];
                case 2:
                    response = _f.sent();
                    customers = (_b = response === null || response === void 0 ? void 0 : response.customers) !== null && _b !== void 0 ? _b : [];
                    matchedCustomer = (_c = customers.find(function (customer) { var _a; return ((_a = customer === null || customer === void 0 ? void 0 : customer.emailId) !== null && _a !== void 0 ? _a : "").toLowerCase() === createdEmail.toLowerCase(); })) !== null && _c !== void 0 ? _c : customers[0];
                    if (!(matchedCustomer === null || matchedCustomer === void 0 ? void 0 : matchedCustomer.customerId)) return [3 /*break*/, 4];
                    customerForSearch = {
                        CustomerId: matchedCustomer === null || matchedCustomer === void 0 ? void 0 : matchedCustomer.customerId,
                        CustomerName: "".concat((_d = matchedCustomer === null || matchedCustomer === void 0 ? void 0 : matchedCustomer.firstName) !== null && _d !== void 0 ? _d : "", " ").concat((_e = matchedCustomer === null || matchedCustomer === void 0 ? void 0 : matchedCustomer.lastName) !== null && _e !== void 0 ? _e : "").trim(),
                        CustomerMailid: matchedCustomer === null || matchedCustomer === void 0 ? void 0 : matchedCustomer.emailId,
                        CompanyName: matchedCustomer === null || matchedCustomer === void 0 ? void 0 : matchedCustomer.companyName,
                        CustomerPhoneno: "",
                    };
                    return [4 /*yield*/, SearchByCustomer(customerForSearch)];
                case 3:
                    _f.sent();
                    return [3 /*break*/, 5];
                case 4:
                    EmptyAllFieldsOnSuccess();
                    _f.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6:
                    error_1 = _f.sent();
                    console.error("Error auto-selecting newly created customer:", error_1);
                    EmptyAllFieldsOnSuccess();
                    return [3 /*break*/, 8];
                case 7:
                    isLoading.next(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var fetchAllCustomers = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var selectFeatures_1, apiParams, response, error_2;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, 3, 4]);
                    selectFeatures_1 = ((_a = salesRepData.baseData) === null || _a === void 0 ? void 0 : _a.select) ? salesRepData.baseData.select : {};
                    if (params === null || params === void 0 ? void 0 : params.isFirstCall) {
                        setIsCustomerFetching(true);
                    }
                    apiParams = {
                        isNextPage: (_b = params === null || params === void 0 ? void 0 : params.isNextPage) !== null && _b !== void 0 ? _b : true,
                        startCursor: (params === null || params === void 0 ? void 0 : params.startCursor) || "",
                        endCursor: (params === null || params === void 0 ? void 0 : params.endCursor) || "",
                        isShowAllCustomer: (_c = selectFeatures_1 === null || selectFeatures_1 === void 0 ? void 0 : selectFeatures_1.showAllCustomer) !== null && _c !== void 0 ? _c : false,
                        isSaveToStore: (_d = params === null || params === void 0 ? void 0 : params.isSaveToStore) !== null && _d !== void 0 ? _d : true,
                    };
                    if (params === null || params === void 0 ? void 0 : params.searchString) {
                        apiParams.searchString = params.searchString;
                    }
                    return [4 /*yield*/, getAllCustomersAction(apiParams)(dispatch)];
                case 1:
                    response = _e.sent();
                    if (response && (response === null || response === void 0 ? void 0 : response.customers)) {
                        updateLocalCustomerState(response);
                    }
                    return [2 /*return*/, response];
                case 2:
                    error_2 = _e.sent();
                    console.error("Error fetching customers:", error_2);
                    return [2 /*return*/, null];
                case 3:
                    if (params === null || params === void 0 ? void 0 : params.isFirstCall) {
                        setIsCustomerFetching(false);
                    }
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSearchCustomers = function (searchTerm) { return __awaiter(_this, void 0, void 0, function () {
        var searchItem, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!searchTerm) return [3 /*break*/, 6];
                    isLoading.next(true);
                    searchItem = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trim();
                    setIsSearching(true);
                    setCurrentSearchTerm(searchItem);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetchAllCustomers({
                            isNextPage: true,
                            searchString: searchItem,
                            endCursor: "",
                            startCursor: "",
                            isSaveToStore: false,
                        })];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _b.sent();
                    console.error("Error searching customers:", error_3);
                    return [3 /*break*/, 5];
                case 4:
                    isLoading.next(false);
                    setIsSearching(false);
                    return [7 /*endfinally*/];
                case 5: return [3 /*break*/, 7];
                case 6:
                    setIsSearching(false);
                    setCurrentSearchTerm("");
                    if (((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.repAllCustomers) === null || _a === void 0 ? void 0 : _a.customers) && salesRepData.repAllCustomers.customers.length > 0) {
                        updateLocalCustomerState(salesRepData.repAllCustomers);
                    }
                    _b.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handlePageChange = function (direction) { return __awaiter(_this, void 0, void 0, function () {
        var isNextPage, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    isLoading.next(true);
                    isNextPage = direction === "next";
                    return [4 /*yield*/, fetchAllCustomers({
                            isNextPage: isNextPage,
                            startCursor: paginationState.startCursor,
                            endCursor: paginationState.endCursor,
                            searchString: currentSearchTerm,
                            isSaveToStore: false,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_4 = _a.sent();
                    console.error("Error in pagination:", error_4);
                    return [3 /*break*/, 4];
                case 3:
                    isLoading.next(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return {
        customerInfo: customerInfo,
        t: t,
        dispatch: dispatch,
        salesRepData: salesRepData,
        addDetailsBtn: addDetailsBtn,
        setAddDetailsBtn: setAddDetailsBtn,
        addShippingAddressBtn: addShippingAddressBtn,
        setAddShippingAddressBtn: setAddShippingAddressBtn,
        errors: errors,
        setErrors: setErrors,
        EmptyFields: EmptyFields,
        SearchByCustomer: SearchByCustomer,
        SearchByCountry: SearchByCountry,
        checkValidation: checkValidation,
        setOrderCreateBtn: setOrderCreateBtn,
        orderCreateBtn: orderCreateBtn,
        tagWiseWholeSalePrices: tagWiseWholeSalePrices,
        customerAddressOptionsData: customerAddressOptionsData,
        setCustomerAddressOptionsData: setCustomerAddressOptionsData,
        editOrderReduxData: editOrderReduxData,
        handleCustomerChange: handleCustomerChange,
        handleGetOptionLabel: handleGetOptionLabel,
        setEditOrderReduxData: setEditOrderReduxData,
        setTagWiseWholeSalePrices: setTagWiseWholeSalePrices,
        handleSelectShippingAddress: handleSelectShippingAddress,
        handleUpdateReduxState: handleUpdateReduxState,
        setCustomerInfo: setCustomerInfo,
        handleManualAddressChange: handleManualAddressChange,
        EmptyAllFieldsOnSuccess: EmptyAllFieldsOnSuccess,
        orderCreatedSuccesfullyFlag: orderCreatedSuccesfullyFlag,
        setOrderCreatedSuccesfullyFlag: setOrderCreatedSuccesfullyFlag,
        getCountriesList: getCountriesList,
        setCustomerDefaultAddress: setCustomerDefaultAddress,
        customerDefaultAddress: customerDefaultAddress,
        addressType: addressType,
        handleNewCustomerModal: handleNewCustomerModal,
        handleMenuAction: handleMenuAction,
        newCustomerModal: newCustomerModal,
        addressModal: addressModal,
        handleAddressModal: handleAddressModal,
        isEditAddress: isEditAddress,
        cancelAddressModal: cancelAddressModal,
        handleSelectAddress: handleSelectAddress,
        handleAutoCountryStateSet: handleAutoCountryStateSet,
        setIsEditAddress: setIsEditAddress,
        manageMenuItems: manageMenuItems,
        getCustomerAddressData: getCustomerAddressData,
        isCustomerSelected: isCustomerSelected,
        setIsCustomerSelected: setIsCustomerSelected,
        customersPopupOpen: customersPopupOpen,
        handleOpenCustomersPopup: handleOpenCustomersPopup,
        handleCloseCustomersPopup: handleCloseCustomersPopup,
        handleCustomerSelectFromPopup: handleCustomerSelectFromPopup,
        handleCreateNewCustomerFromPopup: handleCreateNewCustomerFromPopup,
        handleNewCustomerCreated: handleNewCustomerCreated,
        handlePageChange: handlePageChange,
        localCustomers: localCustomers,
        totalCount: (localCustomers === null || localCustomers === void 0 ? void 0 : localCustomers.length) || 0,
        paginationState: paginationState,
        handleSearchCustomers: handleSearchCustomers,
        isSearching: isSearching,
        currentSearchTerm: currentSearchTerm,
        customerNotHasEmail: customerNotHasEmail,
        HeaderNames: HeaderNames,
        isCustomerFetching: isCustomerFetching,
        showQuantityAdjustedWarning: showQuantityAdjustedWarning,
    };
}
export function CssConstantObjects() {
    var ST_CI_Gridcontainer = {
        mt: 2,
        ml: 0,
    };
    var ST_CI_textfield_BackgrounColor = {
        backgroundColor: "white",
    };
    var ST_CI_textfield_BorderColor = {
        height: 47,
        color: "#1976D2",
        ".MuiOutlinedInput-notchedOutline": { borderColor: "#1976D2" },
    };
    var CrossIcon_Hover = {
        cursor: "pointer",
        transition: "color 0.3s ease",
        "&:hover": {
            color: "rgba(0, 0, 0, 0.26)",
        },
    };
    var ST_CI_displayFlex = {
        flex: 1,
        display: "flex",
    };
    var ST_PopUp_Search_TextField = {
        width: "18rem",
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            boxShadow: "none",
            height: "40px",
            fontSize: "12px",
        },
    };
    return { ST_CI_Gridcontainer: ST_CI_Gridcontainer, ST_CI_textfield_BackgrounColor: ST_CI_textfield_BackgrounColor, ST_CI_textfield_BorderColor: ST_CI_textfield_BorderColor, CrossIcon_Hover: CrossIcon_Hover, ST_CI_displayFlex: ST_CI_displayFlex, ST_PopUp_Search_TextField: ST_PopUp_Search_TextField };
}
